import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2.278 17.753c.267 2.29 2.2 4.109 4.592 4.22 1.653.076 3.342.116 5.174.116 1.833 0 3.522-.04 5.175-.116 2.391-.111 4.325-1.93 4.592-4.22.37-3.182.37-5.891 0-9.073-.267-2.29-2.2-4.109-4.592-4.22a110.62 110.62 0 00-5.175-.116c-1.832 0-3.52.04-5.174.116-2.391.111-4.325 1.93-4.592 4.22-.37 3.182-.37 5.891 0 9.073zM7.628 2v4.42M16.46 2v4.42"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={4}
                y={9.25}
                width={16}
                height={5}
                rx={1.75}
                fill="currentColor"
            />
            <path
                d="M7.63 12.1c-.257 0-.402-.146-.402-.403s.145-.401.402-.401m.003.803c.257 0 .402-.145.402-.402s-.145-.401-.402-.401"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.63 16.92c-.258 0-.402-.144-.402-.401s.144-.402.401-.402m.003.804c.258 0 .402-.145.402-.402s-.144-.402-.402-.402"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.041 12.1c-.257 0-.401-.146-.401-.403s.144-.401.401-.401m.004.803c.257 0 .401-.145.401-.402s-.144-.401-.401-.401"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.041 16.92c-.257 0-.401-.144-.401-.401s.144-.402.401-.402m.004.804c.257 0 .401-.145.401-.402s-.144-.402-.401-.402M16.446 16.92c-.257 0-.402-.144-.402-.401s.145-.402.402-.402m.003.804c.257 0 .402-.145.402-.402s-.145-.402-.402-.402"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.456 12.1c-.257 0-.401-.146-.401-.403s.144-.401.401-.401m.004.803c.257 0 .401-.145.401-.402s-.144-.401-.401-.401"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgComponent;
